// extracted by mini-css-extract-plugin
module.exports = {"label":"TimeSwitcher_label__o6CME"};